<div class="card">
  <h5 class="card-header">
    <div class="card-controls float-right">
      <app-grid-filter-input
        [ngModel]="filterValue$ | async"
        #filter
        (keyup)="filterUsers(filter.value)"
        style="margin-right: 10px;"
      ></app-grid-filter-input>
    </div>
    <div class="card-title">
      Users <span class="badge badge-pill badge-secondary">{{ (gridData$ | async)?.total }}</span>
    </div>
  </h5>

  <kendo-grid
    [data]="gridData$ | async"
    [rowHeight]="rowHeight"
    style="height: calc(100vh - 180px);"
    [resizable]="true"
    [sortable]="{
      allowUnsort: true,
      mode: 'single'
    }"
    [sort]="sort$ | async"
    [scrollable]="'virtual'"
    [loading]="!(loaded$ | async)"
    [pageable]="true"
    [pageSize]="pageSize"
    [skip]="skip$ | async"
    (sortChange)="sortChange($event)"
    (pageChange)="pageChange($event)"
  >
    <kendo-grid-column field="lastName" title="Last Name"></kendo-grid-column>
    <kendo-grid-column field="firstName" title="First Name"></kendo-grid-column>
    <kendo-grid-column [width]="240" field="userName" title="Email">
      <ng-template kendoGridCellTemplate let-user>
        <div>
          <a class="pointer text-primary" (click)="openEditDialog(user)">
            {{ user.username }}
          </a>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="role" title="Role"></kendo-grid-column>
    <kendo-grid-column field="userSites" title="Sites"></kendo-grid-column>
    <kendo-grid-column field="registrationDate" title="Registered">
      <ng-template kendoGridCellTemplate let-user>
        {{ user.registrationDate | date: 'M/d/yy h:mm a' }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="lastLogin" title="Last Login">
      <ng-template kendoGridCellTemplate let-user>
        {{ user.lastLogin | date: 'M/d/yy h:mm a' }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [width]="80" title="Actions">
      <ng-template kendoGridCellTemplate let-user>
        <div class="no-wrap">
          <button
            (click)="openEditDialog(user)"
            title="Edit"
            type="button"
            class="btn btn-outline-primary btn-sm no-wrap"
          >
            <i class="far fa-edit"></i>
          </button>
        </div>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
